import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import useUserLogged from 'src/hooks/useUserLogged';
import { useMetadataMutation } from 'src/redux/api/auth';
import { metadataCompleted } from 'src/redux/slices/auth';
import useError, { reportError } from 'src/screens/error/useError';
import AccountsList from 'src/screens/shared/components/AccountsList';
import AccountItemIcon from 'src/screens/shared/components/AccountsList/AccountItemIcon';
import { AccountItemList } from 'src/screens/shared/components/AccountsList/AccountItemList';
import AvatarEmpty from 'src/screens/shared/components/AvatarEmpty';
import { HeaderModalCustom } from 'src/screens/shared/Styles';

import { AccountSelectorContainer, AccountSelectorModal, AvatarCustom } from './styles';

type Props = {
  isCollapsed: boolean;
  onSubmit: () => void;
};

const AccountSelector = ({ isCollapsed, onSubmit }: Props) => {
  const { currentUser, currentAccount, superAdminToken, isSuperAdminOnlyLogged } = useUserLogged();
  const [showAccountsModal, setShowAccountsModal] = useState(false);
  const { t } = useTranslation();
  const [metadata] = useMetadataMutation();
  const dispatch = useDispatch();
  const { setError } = useError();

  if (!currentAccount || isSuperAdminOnlyLogged) return null;

  const onCancel = () => {
    setShowAccountsModal(false);
  }

  const handleItemSelected = (account: AccountItemList) => {
    metadata(account.id)
      .unwrap()
      .then(response => {
        dispatch(metadataCompleted(response.data));
        setShowAccountsModal(false);
        onSubmit();
      })
      .catch((e) => {
        setError(reportError(e));
      });
  }

  const handleAccountSelectorClick = () => {
    if (superAdminToken || (currentUser?.accounts?.data?.length && currentUser?.accounts?.data?.length > 1)) {
      setShowAccountsModal(true);
    }
  }

  return (
    <>
    <AccountSelectorContainer onClick={handleAccountSelectorClick}>
      <div className={
        classNames(
          { 'collapsed': isCollapsed },
          { 'empty': !currentAccount.logo },
          { 'account-selector-border': true }
        )}>
        {currentAccount.logo ? (
          <AvatarCustom
            src={currentAccount.logo}
            alt={currentAccount.name}
          />
        ) : (
          <AvatarEmpty char1={currentAccount.name.charAt(0)} />
        )}
        {!isCollapsed && <span className="account-name">{currentAccount.name}</span>}
      </div>
    </AccountSelectorContainer>

    {showAccountsModal && (
      <AccountSelectorModal
        onCancel={onCancel}
        open={true}
        maskClosable={false}
        transitionName="fade"
        title={
          <HeaderModalCustom>
            <div>
              <h3>
                <AccountItemIcon icon={'accounts'} />
                {t('layout:select_account_to_operate')}
              </h3>
            </div>
          </HeaderModalCustom>
        }
        footer={null}
        width='400px'
        className='test123'
      >
        <AccountsList
          fetching={false}
          list={currentUser?.accounts.data}
          withSearch={false}
          onItemSelected={handleItemSelected}
          selectable={false}
          skeletonLength={currentUser?.accounts.data.length}
          fixedHeight={currentUser?.accounts.data.length ? currentUser?.accounts.data.length * 50 : 50}
          showBottomFade={false}
        />
      </AccountSelectorModal>
    )}

    
    </>
  );
};

export default AccountSelector;
